import { Link } from "wouter";
import { ChevronRight, Plus, Users } from "lucide-react";
import { useMyGroups } from "@/lib/api/useGroups";

/** The host's groups, with a shortcut to create one. Feature flagged by the caller. */
export function MyGroupsSection() {
  const { data: groupsData } = useMyGroups();

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Users className="w-5 h-5 text-primary-500" />
          <h2 className="text-xl font-semibold dark:text-neutral-100">
            My Groups
          </h2>
        </div>
        <Link
          href="/g/new"
          className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium"
        >
          <Plus className="w-4 h-4" />
          New
        </Link>
      </div>

      {!groupsData?.success || !groupsData.data?.length ? (
        <p className="text-sm text-neutral-500 dark:text-neutral-400 py-2">
          No groups yet.{" "}
          <Link href="/g/new" className="text-primary-500 hover:underline">
            Create one
          </Link>{" "}
          to brand your events.
        </p>
      ) : (
        <div className="space-y-2">
          {groupsData.data.map((g) => (
            <Link
              key={g.id}
              href={`/g/${g.slug}`}
              className="group flex items-center gap-3 p-3 rounded-xl hover:bg-base-200 transition-colors"
            >
              {g.imageUrl ? (
                <img
                  src={g.imageUrl}
                  alt={g.name}
                  className="w-10 h-10 rounded-xl object-cover shrink-0 bg-base-200"
                />
              ) : (
                <div className="w-10 h-10 rounded-xl shrink-0 bg-gradient-to-br from-primary-500/60 via-secondary-500/50 to-accent-500/60 flex items-center justify-center">
                  <Users className="w-4 h-4 text-white/80" />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm leading-tight group-hover:text-primary-500 transition-colors truncate">
                  {g.name}
                </p>
                <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-0.5">
                  {g.eventCount}{" "}
                  {g.eventCount === 1 ? "event" : "events"}
                </p>
              </div>
              <ChevronRight className="w-4 h-4 text-neutral-400 group-hover:text-primary-500 transition-colors shrink-0" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
